module.exports = __webpack_public_path__ + "img/filter-empty.ffa82cc5.svg";